import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FormNumber,
  FormRoot,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { useEffect } from "react";
import { z } from "zod";

const DurationSchema = z.object({
  durationSec: z.coerce.number().int().min(5).max(120),
});

type DurationFormValues = z.infer<typeof DurationSchema>;

type EditPosterDurationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  durationSec: number;
  submitting?: boolean;
  onSubmit: (durationSec: number) => void | Promise<void>;
};

export function EditPosterDurationDialog({
  open,
  onOpenChange,
  durationSec,
  submitting,
  onSubmit,
}: EditPosterDurationDialogProps) {
  const methods = RHF.useForm<DurationFormValues>({
    resolver: zodResolver(DurationSchema),
    defaultValues: { durationSec },
  });

  useEffect(() => {
    if (open) {
      methods.reset({ durationSec });
    }
  }, [open, durationSec]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ເວລາສະແດງ poster</DialogTitle>
          <DialogDescription>
            ກຳນົດເວລາສະແດງ 5–120 ວິນາທີ
          </DialogDescription>
        </DialogHeader>
        <FormRoot
          methods={methods}
          onSubmit={async (values) => {
            await onSubmit(values.durationSec);
          }}
          className="grid gap-4"
        >
          <FormNumber
            name="durationSec"
            label="ເວລາສະແດງ (ວິນາທີ)"
            min={5}
            max={120}
            requiredMark
          />
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              disabled={submitting}
              onClick={() => onOpenChange(false)}
            >
              ຍົກເລີກ
            </Button>
            <Button type="submit" disabled={submitting}>
              {submitting ? "ກຳລັງບັນທຶກ…" : "ບັນທຶກ"}
            </Button>
          </DialogFooter>
        </FormRoot>
      </DialogContent>
    </Dialog>
  );
}
